import api from './api';
import { User } from '../types/user';

export const registerUser = async (name?: string): Promise<User> => {
  const response = await api.post<User>('/api/v1/users/register', name ? { name } : undefined);
  return response.data;
};

export const getCurrentUser = async (): Promise<User> => {
  const response = await api.get<User>('/api/v1/users/me');
  return response.data;
};
